import { SVGIcon } from '@superops/super-icons';
import { TextStyle } from '@superops/ui-design-system';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const DislikeCard = ({ content, noAnimation }) => {
  return (
    <div
      className={`br10 ai-dark-bg ai-dislike-card ${
        noAnimation ? 'no-animation' : ''
      }`}
      id="dislike-card"
    >
      <div className="p10">
        <div className="flex actr jctr">
          <SVGIcon name="ThumbsDownOutline" color="#CCCCCC" size="xl" />
        </div>
        <div className="mt10">
          <TextStyle variation="aiSubdued">
            <div className="fsize12 tcenter">
              <FormattedMessage
                id={content || 'ai.recommended.solutions.dislike.message'}
              />
            </div>
          </TextStyle>
        </div>
      </div>
    </div>
  );
};

export default DislikeCard;
